/*
  HHL: the cart drawer's lines move instead of jumping (owner 2026-10-20: a part going from on its own into a "Verified
  compatible" bubble was "jarring. Make that slick").

  The theme redraws the drawer by replacing its whole inside (theme.js CartDrawer._rerenderCart sets innerHTML). This
  wraps that one setter on <cart-drawer>: it notes where each line (by its line key) and each bubble sat, lets the
  theme draw, then plays the change (FLIP):
  - a line that was there glides from its old spot to its new one;
  - a new line fades and rises in;
  - a bubble that is new or changed grows from around its lines' old spots to its own size, its tint fading in;
  - a bubble that is gone (or changed) leaves a copy with its own look that fades out where it was;
  - a bubble that stays the same slides, its lines with it;
  - the photos already shown stay (the redraw's copies of them would blank while loading).
  Positions are taken inside the drawer's scrolling area, so the scroll the theme puts back after drawing changes
  nothing. Reduced motion: no movement at all. It works for the docked cart too (wide screens, custom.js "Docked
  cart"), which the theme never marks open.
*/
(function () {
  if (window.hhlCartMotion) return;
  window.hhlCartMotion = true;

  var EASE = "cubic-bezier(0.22, 1, 0.36, 1)";
  var MOVE = 420;
  var htmlSetter = Object.getOwnPropertyDescriptor(Element.prototype, "innerHTML").set;

  /** The line's key, from its quantity box (name="updates[KEY]"). */
  function keyOf(line) {
    var input = line.querySelector('input[name^="updates["]');
    return input ? input.name.slice(8, -1) : "";
  }

  /** A box inside the drawer's scrolling area: the same whatever the scroll. */
  function boxIn(scroller, el) {
    var s = scroller.getBoundingClientRect();
    var r = el.getBoundingClientRect();
    return { top: r.top - s.top + scroller.scrollTop, left: r.left - s.left, width: r.width, height: r.height };
  }

  function union(boxes) {
    if (!boxes.length) return null;
    var top = Infinity, left = Infinity, bottom = -Infinity, right = -Infinity;
    boxes.forEach(function (b) {
      top = Math.min(top, b.top); left = Math.min(left, b.left);
      bottom = Math.max(bottom, b.top + b.height); right = Math.max(right, b.left + b.width);
    });
    return { top: top, left: left, width: right - left, height: bottom - top };
  }

  /** What the drawer shows now: each line's box by key, each bubble's box and its line keys. */
  function measure(drawer) {
    var scroller = drawer.querySelector(".drawer__content");
    if (!scroller) return null;
    var lines = {};
    drawer.querySelectorAll("line-item").forEach(function (line) {
      var key = keyOf(line);
      if (key) lines[key] = { el: line, box: boxIn(scroller, line) };
    });
    var groups = [];
    drawer.querySelectorAll(".hhl-fit-group").forEach(function (group) {
      var keys = [];
      group.querySelectorAll("line-item").forEach(function (line) { var k = keyOf(line); if (k) keys.push(k); });
      // Its look, read now: once the drawer is redrawn this element is gone, and a gone element has no styles (the
      // copy that fades out came out square and bare, owner 2026-10-20)
      // (a bubble still easing in is settled first, so the copy has its full look, not a half-faded one)
      if (group.getAnimations) group.getAnimations().forEach(function (run) { run.finish(); });
      var cs = getComputedStyle(group);
      var look = { bg: cs.backgroundColor, bw: cs.borderTopWidth, bc: cs.borderTopColor, r: cs.borderTopLeftRadius };
      groups.push({ el: group, box: boxIn(scroller, group), keys: keys.sort().join("|"), list: keys, look: look });
    });
    return { scroller: scroller, lines: lines, groups: groups };
  }

  function play(drawer, before) {
    var after = measure(drawer);
    if (!before || !after) return;
    var radius = getComputedStyle(document.documentElement).getPropertyValue("--hhl-radius-card").trim() || "8px";
    var oldGroups = {};
    before.groups.forEach(function (g) { oldGroups[g.keys] = g; });
    var newGroups = {};
    after.groups.forEach(function (g) { newGroups[g.keys] = g; });

    // A bubble that stays the same only slides; its lines ride along with it, so they move by the rest
    var slide = function (g) {
      var same = oldGroups[g.keys];
      return same ? same.box.top - g.box.top : 0;
    };

    // Lines: from where they were, or in from nothing
    Object.keys(after.lines).forEach(function (key) {
      var now = after.lines[key];
      var was = before.lines[key];
      if (was) {
        var home = now.el.closest(".hhl-fit-group");
        var ride = 0;
        after.groups.forEach(function (g) { if (g.el === home) ride = slide(g); });
        var dx = was.box.left - now.box.left;
        var dy = was.box.top - now.box.top - ride;
        if (Math.abs(dx) < 1 && Math.abs(dy) < 1) return;
        now.el.animate({ transform: ["translate(" + dx + "px," + dy + "px)", "none"] }, { duration: MOVE, easing: EASE });
      } else {
        now.el.animate({ opacity: [0, 1], transform: ["translateY(8px)", "none"] }, { duration: MOVE, easing: EASE });
      }
    });

    // New or changed bubbles: grow from around their lines' old spots
    after.groups.forEach(function (g) {
      if (oldGroups[g.keys]) {
        var dy = slide(g);
        if (Math.abs(dy) >= 1) g.el.animate({ transform: ["translateY(" + dy + "px)", "none"] }, { duration: MOVE, easing: EASE });
        return;
      }
      var from = union(g.list.map(function (k) { return before.lines[k] && before.lines[k].box; }).filter(Boolean)) || g.box;
      var inset = [from.top - g.box.top, g.box.left + g.box.width - (from.left + from.width), g.box.top + g.box.height - (from.top + from.height), from.left - g.box.left]
        .map(function (n) { return Math.max(0, n) + "px"; }).join(" ");
      var styles = getComputedStyle(g.el);
      g.el.animate({
        clipPath: ["inset(" + inset + " round " + radius + ")", "inset(0 0 0 0 round " + radius + ")"],
        backgroundColor: ["transparent", styles.backgroundColor],
        borderColor: ["transparent", styles.borderTopColor],
      }, { duration: MOVE, easing: EASE });
      var label = g.el.querySelector(".hhl-fit-group__label");
      if (label) label.animate({ opacity: [0, 1] }, { duration: MOVE, delay: MOVE / 3, easing: EASE, fill: "backwards" });
    });

    // Gone or changed bubbles: a copy with the bubble's own look (rounded, its tint and border) fades out where it
    // was, settling slightly, while its lines glide away (owner 2026-10-20: the outline that resized itself was
    // "janky"). Opacity and transform only: no size changes frame by frame.
    var scroller = after.scroller;
    // Its own stacking layer, so a copy drawn below (z-index -1) sits under the lines but over the drawer's background
    if (getComputedStyle(scroller).position === "static") scroller.style.position = "relative";
    scroller.style.isolation = "isolate";
    before.groups.forEach(function (g) {
      if (newGroups[g.keys]) return;
      var look = g.look;
      var ghost = document.createElement("div");
      ghost.setAttribute("aria-hidden", "true");
      ghost.style.cssText = "position:absolute;pointer-events:none;box-sizing:border-box;z-index:-1;" +
        "top:" + g.box.top + "px;left:" + g.box.left + "px;width:" + g.box.width + "px;height:" + g.box.height + "px;" +
        "background:" + look.bg + ";border:" + look.bw + " solid " + look.bc + ";border-radius:" + (look.r && look.r !== "0px" ? look.r : radius);
      scroller.appendChild(ghost);
      var run = ghost.animate({ opacity: [1, 0], transform: ["none", "scale(0.985)"] }, { duration: MOVE, easing: "cubic-bezier(0.4, 0, 0.2, 1)" });
      run.onfinish = run.oncancel = function () { ghost.remove(); };
    });
  }

  function wrap(proto) {
    if (!proto || proto.hhlCartMotion) return;
    proto.hhlCartMotion = true;
    Object.defineProperty(proto, "innerHTML", {
      configurable: true,
      get: Object.getOwnPropertyDescriptor(Element.prototype, "innerHTML").get,
      set: function (html) {
        var before = null;
        // Whenever the cart is laid out: open, docked beside the page on wide screens (no "open" attribute there), or
        // closed and about to slide open after an add (it still has its size off screen, so the change plays as it
        // comes in). Not when it isn't drawn at all.
        var content = this.querySelector(".drawer__content");
        if (!HHL.mq.reducedMotion.matches && content && content.getBoundingClientRect().width > 0) {
          try { before = measure(this); } catch (e) { before = null; }
        }
        var photos = before ? [].slice.call(this.querySelectorAll("line-item img")) : [];
        htmlSetter.call(this, html);
        // What other scripts add to the drawer (the HHL app's "Complete your …" in each bubble) goes back now, before
        // the new layout is measured, so it is part of the motion instead of appearing a frame later.
        this.dispatchEvent(new CustomEvent("hhl:cart-redrawn", { bubbles: true }));
        if (before) {
          // The redraw brings new <img>s of the same photos, which blank while they load and decode (glitchy as they
          // move): the shown ones, already loaded, go back in their place.
          var kept = {};
          photos.forEach(function (img) { if (img.complete && img.getAttribute("src")) kept[img.getAttribute("src")] = img; });
          this.querySelectorAll("line-item img").forEach(function (img) {
            var old = kept[img.getAttribute("src")];
            if (old && (old.getAttribute("srcset") || "") === (img.getAttribute("srcset") || "")) {
              delete kept[img.getAttribute("src")];
              img.replaceWith(old);
            }
          });
          try { play(this, before); } catch (e) { /* motion is extra: the drawer is already right */ }
        }
      },
    });
  }

  if (window.customElements) window.customElements.whenDefined("cart-drawer").then(function () { wrap(window.customElements.get("cart-drawer").prototype); });
})();
